export default __webpack_public_path__ + "static/media/store-level-1.6a9fe54c.png";